import React, { useState, useEffect, useRef } from 'react';
import i18next from '../../i18n.js';
import { Button } from 'react-bootstrap';
import { acceptImageFileString, allowedImageFileExtensions, maxFileSize, formModes } from '../../constants.js';
import { getFileAttachmentErrorMessage } from '../helpers/CheckFunctions.js';
import { errorMessageDialog } from '../ModalDialog.js';
import CropControl from './CropControl.js';

const CropInput = (props) => {
    const [imageUrl, setImageUrl] = useState(props.value);
    const [newImageUrl, setNewImageUrl] = useState('');
    const [formMode, setFormMode] = useState(formModes.read);
    const fileInputRef = useRef(null);

    useEffect(() => {
        if (props.value) {
            setFormMode(formModes.read);
            setNewImageUrl('');
            setImageUrl(props.value);
        }
    }, [props.value])

    useEffect(() => {
        if (props.disabled) {
            setFormMode(formModes.read);
            setNewImageUrl('');
        }
    }, [props.disabled])

    const onFileChanged = (e) => {
        e.persist();
        if (e.target.files && e.target.files.length > 0) {
            const errorMessage = getFileAttachmentErrorMessage(e.target.files[0], allowedImageFileExtensions, maxFileSize);
            if (errorMessage) {
                errorMessageDialog(errorMessage);
            }
            else {
                var fileReader = new FileReader();
                fileReader.addEventListener('load', () => {
                    setNewImageUrl(fileReader.result);
                    setFormMode(formModes.edit);
                    fileInputRef.current.value = '';
                }, false);
                fileReader.readAsDataURL(e.target.files[0]);
            }
        }
    }

    const onEditBtnClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }

    const onCropChanged = (value) => {
        if (props.onChange) {
            props.onChange({
                target: {
                    name: props.name,
                    value: {
                        image: newImageUrl,
                        crop: value
                    }
                }
            });
        }
    }

    return (<div className="crop-input">
        {(formMode === formModes.read || props.disabled) && imageUrl && <img className="crop-input-img" src={imageUrl} />}
        {!props.disabled && formMode === formModes.edit && newImageUrl && <CropControl imageUrl={newImageUrl} onChange={onCropChanged} />}
        {!props.disabled && <Button className='edit-btn' onClick={onEditBtnClick}>{i18next.t('other.editCropText')}</Button>}
        <input ref={fileInputRef} onChange={onFileChanged} type="file" style={{ display: "none" }} accept={acceptImageFileString} />
    </div>);
}

export default CropInput;